/* jshint esversion: 11 */
/* jshint ignore:start */

import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import { showTost } from '../showTost';

const Payfast = ({ Amount, ItemType, ItemId }) => {
    const { basUrl, page, setPayClose, setPlanId, setBuyCoin } = useContext(MyContext);
    const [started, setStarted] = useState(false);

    useEffect(() => {
        if (!Amount || started) return;

        const startPayfastCheckout = async () => {
            setStarted(true);

            try {
                const localData = localStorage.getItem("Register_User");
                if (!localData) {
                    throw new Error("Login required for payment.");
                }

                const userData = JSON.parse(localData);
                const itemType = ItemType || (page === "Upgrade" ? "plan" : page === "Wallet" ? "wallet" : "package");
                const itemId = ItemId || 0;
                const currentUrl = window.location.href.split("?")[0];

                const orderRes = await axios.post(`${basUrl}create_payment_order`, {
                    uid: userData.id,
                    item_type: itemType,
                    item_id: itemId,
                    amount: Amount,
                    payment_gateway: "Payfast",
                    customer_email: userData.email || "",
                    customer_name: userData.name || "",
                    success_url: currentUrl,
                    cancel_url: currentUrl,
                });

                if (orderRes.data.Result !== "true") {
                    throw new Error(orderRes.data.ResponseMsg || "Unable to create Payfast checkout.");
                }

                if (!orderRes.data.checkout || !orderRes.data.checkout.url) {
                    throw new Error("Payfast checkout URL missing from backend.");
                }

                localStorage.setItem("PayfastPendingPayment", JSON.stringify({
                    order_id: orderRes.data.order_id,
                    gateway_order_id: orderRes.data.checkout.gateway_order_id,
                    item_type: itemType,
                    item_id: itemId,
                    amount: Amount,
                    page,
                }));

                window.location.href = orderRes.data.checkout.url;
            } catch (err) {
                showTost({ title: err.message || "Unable to start Payfast payment." });
                if (page === "Upgrade") {
                    setPlanId("PaymentNotDone");
                } else if (page === "Wallet") {
                    setPayClose("PaymentNotDone");
                } else {
                    setBuyCoin("PaymentNotDone");
                }
            }
        };

        startPayfastCheckout();
    }, [Amount, ItemId, ItemType, basUrl, page, setBuyCoin, setPayClose, setPlanId, started]);

    return (
        <div className="w-[100%] text-center py-[20px]">
            <h6 className="m-0">Redirecting to Payfast Checkout...</h6>
        </div>
    );
};

export default Payfast;
/* jshint ignore:end */
